function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m747.6 680.4 43.199 212.4-190.8-106.8-190.8 106.8 43.199-212.4-160.8-146.4 217.2-25.199 91.199-195.6 91.199 196.8 217.2 25.199z",
  fill: "#474747"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    version: 1.1,
    viewBox: "0 0 1200 1200"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/story-featured.585919d1.svg";
export { SvgComponent as ReactComponent };